import React, { PropsWithChildren } from "react";

import { useBulkActionBar } from "./contexts/bulk-action-bar-context";
import { BulkActionBar as BulkActionBarComponent } from "./bulk-action-bar";

export type BulkActionBarProps = object;

/**
 * Public component :  Bulk Action Bar ( only has children )
 */
export const BulkActionBar = ({
  children
}: PropsWithChildren<BulkActionBarProps>) => {
  const context = useBulkActionBar();
  if (context.selectedRows.length > 0) {
    return children !== null ? (
      <BulkActionBarComponent {...context}>{children}</BulkActionBarComponent>
    ) : null;
  }
  return null;
};
